/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserPushSubscriptionMutationVariables = Types.Exact<{
  input: Types.UserUpdateInput;
}>;


export type UpdateUserPushSubscriptionMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string } | null };


export const UpdateUserPushSubscriptionDocument = gql`
    mutation UpdateUserPushSubscription($input: UserUpdateInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;
export type UpdateUserPushSubscriptionMutationFn = Apollo.MutationFunction<UpdateUserPushSubscriptionMutation, UpdateUserPushSubscriptionMutationVariables>;

/**
 * __useUpdateUserPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateUserPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPushSubscriptionMutation, { data, loading, error }] = useUpdateUserPushSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPushSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPushSubscriptionMutation, UpdateUserPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPushSubscriptionMutation, UpdateUserPushSubscriptionMutationVariables>(UpdateUserPushSubscriptionDocument, options);
      }
export type UpdateUserPushSubscriptionMutationHookResult = ReturnType<typeof useUpdateUserPushSubscriptionMutation>;
export type UpdateUserPushSubscriptionMutationResult = Apollo.MutationResult<UpdateUserPushSubscriptionMutation>;
export type UpdateUserPushSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateUserPushSubscriptionMutation, UpdateUserPushSubscriptionMutationVariables>;